import Cookies from "universal-cookie";
import axios from "axios";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const estimatePipelineCost = async (data) => {
    const url = `${API_BASE}/research-pipeline/estimate-cost`;
    return axios.post(url, data, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
};

export const createResearchPipeline = async (formData) => {
    const url = `${API_BASE}/research-pipeline`;
    return axios.post(url, formData, {
        headers: { 
            authorization: `Bearer ${getToken()}`,
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const getResearchPipelines = async (teamUuid, filters = {}) => {
    const url = `${API_BASE}/research-pipeline`;
    const params = { team_uuid: teamUuid, ...filters };
    return axios.get(url, { 
        params,
        headers: { authorization: `Bearer ${getToken()}` } 
    });
};

export const getResearchPipeline = async (uuid, teamUuid) => {
    const url = `${API_BASE}/research-pipeline/${uuid}`;
    const params = { team_uuid: teamUuid };
    return axios.get(url, { 
        params,
        headers: { authorization: `Bearer ${getToken()}` } 
    });
};

export const retryPipelineStep = async (pipelineUuid, stepName, teamUuid) => {
    const url = `${API_BASE}/research-pipeline/${pipelineUuid}/retry-step/${stepName}`;
    const data = { team_uuid: teamUuid };
    return axios.post(url, data, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
};

export const cancelPipeline = async (pipelineUuid, teamUuid) => {
    const url = `${API_BASE}/research-pipeline/${pipelineUuid}/cancel`;
    const data = { team_uuid: teamUuid };
    return axios.post(url, data, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
};

export const deletePipeline = async (pipelineUuid, teamUuid) => {
    const url = `${API_BASE}/research-pipeline/${pipelineUuid}`;
    const data = { team_uuid: teamUuid };
    return axios.delete(url, { 
        data,
        headers: { authorization: `Bearer ${getToken()}` } 
    });
};